import script from "./AdminDashboardNominationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardNominationModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardNominationModal.vue?vue&type=style&index=0&id=b080a3a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b080a3a0"]])

export default __exports__